export const SELECTED_MAP_LAYERS = 'SELECTED_MAP_LAYERS';
export const SELECTED_BASEMAP = 'SELECTED_BASEMAP';
export const RECENT_SEARCHES = 'RECENT_SEARCHES';
export const DETAIL_PANE_SIZE = 'DETAIL_PANE_SIZE';
export const LS_LAST_UPDATED_VERSION = 'LAST_UPDATED_VERSION';
